import { parseUnits } from "viem";

export const adjustPriceDown = (price: bigint, decimal: number) => {
  const one = parseUnits("1", decimal);
  if (price > one) price = one;

  return price;
};

export const adjustPriceUp = (price: bigint, decimal: number) => {
  const one = parseUnits("1", decimal);
  if (price < one) price = one;

  return price;
};
